<template>
  <div id="group-table-component">

    <div class="d-flex justify-end mb-2">
      <memlist-icon-button
        class="mr-2"
        icon="menu-icon flaticon2-plus"
        :text="$t('ACCESS.GROUP.CREATE')"
        variant="primary"
        @click="new_group_clicked"
      />
    </div>

    <memlist-static-table
      id="group-table"
      style="width: 100%; table-layout: fixed;"
      class="table-striped"
      :fields="fields"
      :items="items"
      head-variant="light"
      ref="groupTable"
      :tbody-tr-class="row_class"
    >
      <template #cell(actions)="data">
        <div class='d-flex justify-content-end'>
          <memlist-table-button class="mr-3" @click="edit_group_clicked(data.item)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')"/>
          <memlist-table-button @click="delete_group_clicked(data.item)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />
        </div>
      </template>
    </memlist-static-table>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';


export default {
  name: 'GroupTable',
  components: {

  },
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'pages']),

  },
  props: ['items'],
  emits: ['selected', 'create', 'delete'],
  async mounted() {

  },
  methods: {

    edit_group_clicked(item) {
      this.$emit('selected', item);
    },

    delete_group_clicked(item) {
      this.$emit('delete', item.id);
    },

    new_group_clicked() {
      this.$emit('create');
    },


  },
  data() {
    return {

      group: {},

      fields: [
        {
          key: 'id',
          label: this.$t('ACCESS.GROUP.ID'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short2',
          thClass: 'td-short2'
        },
        {
          key: 'name',
          label: this.$t('ACCESS.GROUP.NAME'),
          sortable: false,
          mobile: true,
          tdClass: 'td-overflow-wide ',
          thClass: 'td-overflow-wide '
        },
        {
          key: 'created_at',
          label:  this.$t('ACCESS.GROUP.CREATED_AT'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short4',
          thClass: 'td-short4'
        },
        {
          key: 'actions',
          label: this.$t('COMMON.ACTIONS'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short4',
          thClass: 'td-short4'

        },
      ],
    };
  },
  watch: {


  },

};
</script>
